module.exports = __webpack_public_path__ + "media/images/hero_images/brand-3000-65c8b032de62317029f7e856eb2f64fd.jpg";